import React from "react";
import { connect } from "react-redux";
import * as R from "ramda";
import { getIsSubSessionButton } from "EventLight/Sessions/AddSessionModal/selectors";
import { actions, getters } from "EventLight/Sessions/AddSessionModal/model";
import { Div, BigOutlineButton } from "components/Base";
import { WithFormInstanceProvider } from "ui-kit/Form/View";
import {
  SESSION_FORM_ID,
  FROM_SESSION_PAGE
} from "EventLight/Sessions/AddSessionModal/constants";
import {
  TABS,
  SUBSESSIONS_TAB,
  SESSION_MODAL_TABS_INSTANCE_ID
} from "EventLight/Sessions/AddSessionModal/constants";
import { getters as TabGetters } from "ui-kit/Tabs";
import { noop } from "lodash";

const decorate = R.compose(
  WithFormInstanceProvider(R.always(SESSION_FORM_ID)),
  connect(
    state => ({
      getIsSubSessionButton: getIsSubSessionButton(state),
      loading: getters.loading(state),
      isSubsession: getters.isSubsession(state),
      linkSessionsToSubsessionsTab: getters.linkSessionsToSubsessionsTab(state),
      activeTab: TabGetters.selectedTab(state, {
        instanceId: SESSION_MODAL_TABS_INSTANCE_ID
      }),
      returnToScene: getters.returnToScene(state)
    }),
    {
      backSelectedSubssesionsButton: actions.backSelectedSubssesionsButton,
      setLinkSessionsToSubsessionsTab: actions.setLinkSessionsToSubsessionsTab,
      setActiveSubsessionsIndex: actions.setActiveSubsessionsIndex,
      linkSessionAsSubsession: actions.linkSessionAsSubsession
    }
  )
);

const Footer = ({
  setLinkSessionsToSubsessionsTab = noop,
  setActiveSubsessionsIndex = noop,
  backSelectedSubssesionsButton = noop,
  linkSessionAsSubsession = noop,
  linkSessionsToSubsessionsTab = SUBSESSIONS_TAB.SELECT_SESSIONS,
  activeTab,
  getIsSubSessionButton = false,
  returnToScene
  // handlers = {}
}) => {
  if (
    (activeTab === TABS.SUBSESSIONS || returnToScene === FROM_SESSION_PAGE) &&
    linkSessionsToSubsessionsTab === SUBSESSIONS_TAB.SELECT_SESSIONS
  ) {
    return (
      <Div
        bg="white"
        bt={1}
        bc="neutral2"
        height={65}
        display="row.flex-start.center"
        py={3}
        px={6}
        style={{ gap: "12px" }}
      >
        {returnToScene !== FROM_SESSION_PAGE && (
          <BigOutlineButton
            width={100}
            display="row.center.center"
            bg="white"
            color="neutral5"
            onClick={() => {
              backSelectedSubssesionsButton();
            }}
          >
            Back
          </BigOutlineButton>
        )}

        <BigOutlineButton
          width={100}
          display="row.center.center"
          bg="altB5"
          color="white"
          onClick={() => {
            setLinkSessionsToSubsessionsTab(
              SUBSESSIONS_TAB.CONVERT_TO_SUBSESSIONS
            );
            setActiveSubsessionsIndex(1);
          }}
          disabled={getIsSubSessionButton}
        >
          Confirm
        </BigOutlineButton>
      </Div>
    );
  }

  if (
    (activeTab === TABS.SUBSESSIONS || returnToScene === FROM_SESSION_PAGE) &&
    linkSessionsToSubsessionsTab === SUBSESSIONS_TAB.CONVERT_TO_SUBSESSIONS
  ) {
    return (
      <Div
        bg="white"
        bt={1}
        bc="neutral2"
        height={65}
        p={6}
        display="row.flex-start.center"
        py={3}
        px={6}
      >
        <BigOutlineButton
          width={100}
          display="row.center.center"
          bg="white"
          color="neutral5"
          onClick={() => {
            setLinkSessionsToSubsessionsTab(SUBSESSIONS_TAB.SELECT_SESSIONS);
            setActiveSubsessionsIndex(0);
          }}
        >
          Back
        </BigOutlineButton>

        <BigOutlineButton
          width={100}
          display="row.center.center"
          bg="altB5"
          color="white"
          disabled={getIsSubSessionButton}
          onClick={() => linkSessionAsSubsession()}
          ml={3}
        >
          Save
        </BigOutlineButton>
      </Div>
    );
  }

  return <></>;
};

export default decorate(Footer);
